//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'questionnaireDetail',
    data() {
        return {
            id: 0,
            loading: false,
            questionnaireInfo: {},
            list: [],
            saving: false,
            checkAllGroup: []
        };
    },
    methods: {
        getQuestionnaireInfo() {
            this.loading = true;
            this.$store.dispatch({
                type: 'questionnaire/getQuestionnaireById',
                id: this.id
            }).then(() => {
                this.questionnaireInfo = {
                    memberLevel: ''
                };
                this.questionnaireInfo = this.$store.state.questionnaire.questionnaireInfo;
                if (this.questionnaireInfo.memberLevel && this.questionnaireInfo.memberLevel.length > 0) {
                    this.checkAllGroup = this.questionnaireInfo.memberLevel.split(',');
                }
                this.getQuestions();
            }).finally(() => {
                this.loading = false;
            });
        },
        getQuestions() {
            abp.ajax.get('/api/services/app/Questionnaire/GetQuestions?id=' + this.id).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
            });
        },
        editQuestionnaire() {
            this.$router.push({
                name: 'questionnaireEdit',
                params: {
                    id: this.id
                }
            });
        },
        onCancelRelease() {
            this.saving = true;
            abp.ajax.post('/api/services/app/Questionnaire/CancelRelease?id=' + this.id).then(res => {
                this.getQuestionnaireInfo();
            }).finally(() => {
                this.saving = false;
            });
        },
        delQuestionnaire() {
            const vm = this;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认删除' + this.questionnaireInfo.name + '吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {
                    vm.loading = true;
                    vm.$store.dispatch({
                        type: 'questionnaire/delQuestionnaire',
                        id: this.id
                    }).then(() => {
                        vm.$router.push({ name: 'questionnaire' });
                    }).finally(() => {
                        vm.loading = false;
                    });

                }
            });
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        }
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        if (this.id > 0) {
            this.getQuestionnaireInfo();
        }
    }
};
